const AUTH_SELF_LOOPS = new Set(['/login', '/register', '/forgot-password', '/reset-password']);

// Returns true only for internal root-relative paths that aren't auth pages themselves.
// Rejects: null/undefined, absolute URLs (contain ://), protocol-relative (start with //),
// non-root-relative paths (don't start with /), and auth self-loop paths.
export function isSafeRedirect(path: string | null | undefined): path is string {
  if (!path) return false;
  if (path.startsWith('//')) return false;
  if (path.includes('://')) return false;
  if (!path.startsWith('/')) return false;
  const pathname = path.replace(/[?#].*$/, '');
  if (AUTH_SELF_LOOPS.has(pathname)) return false;
  return true;
}
